import { Alert } from '@mui/material'
import DashboardLayout from './DashboardLayout'

type Props = {
    loading?: boolean
    error: string
}

const DashboardErrorView = (props: Props) => {
    return (
        <DashboardLayout loading={props.loading}>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    paddingTop: 64,
                }}
            >
                <div>
                    <Alert severity="error">{props.error}</Alert>
                </div>
            </div>
        </DashboardLayout>
    )
}

export default DashboardErrorView
